import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Container,
    Typography,
    Button,
    Card,
    CardContent,
    Grid,
    Avatar,
} from '@mui/material';
import { ExitToApp as LogoutIcon, Person as PersonIcon } from '@mui/icons-material';
import axios from 'axios';
import { internshipDomain } from '../../util/domain';

const UserHome = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) {
            navigate('/admin');
            return;
        }

        // Get user info from localStorage
        const userData = JSON.parse(localStorage.getItem('user') || '{}');
        setUser(userData);
        setLoading(false);

        // Verify token is still valid
        // You can add API call here to verify token
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/admin');
    };

    if (loading) {
        return (
            <Container maxWidth="md">
                <Box sx={{ mt: 8, textAlign: 'center' }}>
                    <Typography>Loading...</Typography>
                </Box>
            </Container>
        );
    }

    return (
        <Container maxWidth="md">
            <Box sx={{ mt: 8 }}>
                <Card>
                    <CardContent>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                            <Typography variant="h4" component="h1">
                                Welcome to Vector India
                            </Typography>
                            <Button
                                variant="outlined"
                                color="error"
                                startIcon={<LogoutIcon />}
                                onClick={handleLogout}
                            >
                                Logout
                            </Button>
                        </Box>

                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <Avatar sx={{ mr: 2, bgcolor: 'primary.main' }}>
                                        <PersonIcon />
                                    </Avatar>
                                    <Box>
                                        <Typography variant="h6">
                                            {user?.email || 'User'}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Role: {Array.isArray(user?.roles) ? user.roles.join(', ') : user?.roles || 'User'}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid item xs={12}>
                                <Card variant="outlined">
                                    <CardContent>
                                        <Typography variant="h6" gutterBottom>
                                            Access Information
                                        </Typography>
                                        <Typography variant="body1" paragraph>
                                            You have successfully logged in. However, you don't have administrative privileges
                                            to access the admin panel.
                                        </Typography>
                                        <Typography variant="body1" paragraph>
                                            If you need access to the admin panel, please contact your system administrator.
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12}>
                                <Card variant="outlined">
                                    <CardContent>
                                        <Typography variant="h6" gutterBottom>
                                            Available Features
                                        </Typography>
                                        <Typography variant="body1" component="div">
                                            <ul>
                                                <li>View your profile information</li>
                                                <li>Access basic features</li>
                                                <li>Contact support if needed</li>
                                            </ul>
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                                    <Button
                                        variant="contained"
                                        onClick={() => navigate('/')}
                                    >
                                        Go to Main Site
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Container>
    );
};

export default UserHome;

